import { cn } from "@/lib/utils";
import ChevronDownIcon from "lucide-solid/icons/chevron-down";
import { type ComponentProps, Show, splitProps } from "solid-js";

export type LandingSectionProps = ComponentProps<"section"> & {};

export function LandingSection(props: LandingSectionProps) {
  const [local, rest] = splitProps(props, ["class", "children"]);

  return (
    <section
      class={cn("flex flex-col border-grid border-b", local.class)}
      {...rest}
    >
      <div class={cn("container-wrapper relative grow bg-background")}>
        {local.children}
      </div>
    </section>
  );
}

export function LandingSectionContent(props: ComponentProps<"div">) {
  const [local, rest] = splitProps(props, ["class", "children"]);

  return (
    <div
      class={cn(
        "relative flex min-h-[720px] w-full flex-col items-stretch justify-center px-4 pt-4 pb-8 md:items-start md:px-12 md:py-12",
        local.class,
      )}
      {...rest}
    >
      {local.children}
    </div>
  );
}

export function LandingSectionTitle(props: ComponentProps<"h2">) {
  const [local, rest] = splitProps(props, ["class", "children"]);

  return (
    <h2
      class={cn(
        "pointer-events-none select-none font-medium font-mono text-muted-foreground/50 text-xs uppercase",
        local.class,
      )}
      {...rest}
    >
      {local.children}
    </h2>
  );
}

export function LandingSectionHeader(props: ComponentProps<"div">) {
  const [local, rest] = splitProps(props, ["class", "children"]);

  return (
    <div
      class={cn(
        "group absolute right-1 bottom-1 inline-flex items-center gap-2 px-0.5",
        local.class,
      )}
      {...rest}
    >
      {local.children}
    </div>
  );
}

export function LandingSectionFooter(props: ComponentProps<"div">) {
  const [local, rest] = splitProps(props, ["class", "children"]);

  return (
    <div class={cn("absolute right-[50%] bottom-3")} {...rest}>
      <Show
        when={local.children}
        fallback={<ChevronDownIcon class="size-6 text-muted-foreground/80" />}
      >
        {local.children}
      </Show>
    </div>
  );
}
